
export {default as CollegeHelper} from './college';
// export {default as AdminHelper} from './admin';
// export {default as SMEHelper} from './sme';
// export {default as StudentHelper} from './student';



import CollegeHelper from './college';
// import AdminHelper from './admin';
// import SMEHelper from './sme';
// import StudentHelper from './student';


const AdminHelpers = {
    college: CollegeHelper,
    // admin: AdminHelper,
    // sme: SMEHelper,
    // student: StudentHelper,
};

export default AdminHelpers;